import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Notification from '@zg-rentals/multibrand-ui/lib/Notification';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import api from '../../../utils/api';
import queryUtil from '../../../utils/queryUtils';
import './style.scss';

const WaitlistConfirmationPage = () => {
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const location = useLocation();
  const { hash, leadId, sendEmail } = queryUtil.parse(location.search);
  // URLSearchParams is used for userName to parse the + as a space

  const params = new URLSearchParams(location.search);
  const userName = params.get('userName');

  useEffect(() => {
    dispatch(api.waitlistConfirmation.confirmWaitlist(leadId, hash, sendEmail))
      .then((response) => {
        if (!response.success) {
          throw response.error?.message;
        }
        return;
      })
      .catch((err) => {
        setError(
          typeof error === 'string'
            ? `Oops! There was an error: ${err}`
            : 'Oops! Something went wrong. Please try again.',
        );
      });
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, [dispatch, leadId, hash, sendEmail]);

  return (
    <div className="waitlistConfirmationContainer">
      {error && (
        <SpacerRow size="lg">
          <Notification type="error" onClose={() => setError('')}>
            {error}
          </Notification>
        </SpacerRow>
      )}
      <Center>
        <SpacerRow size="lg">
          <Text type="hero">{sendEmail ? `Thank you ${userName} for confirming!` : 'Congrats on your new home!'}</Text>
        </SpacerRow>
        <SpacerRow size="lg">
          <Text type="h4">
            {sendEmail
              ? `Your message has been sent to the property`
              : 'We will not share your message with this property'}
          </Text>
        </SpacerRow>
      </Center>
    </div>
  );
};

export default WaitlistConfirmationPage;
